import api from "@services/axiosInstance";

function ping() {
  return api.get("/");
}

export default {
  ping,
};
